// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__iVHZ6","header":"MergedInvoice_header__2dzMk"};